export const DEFAULT_WINNING_DISCOUNTS = Object.freeze([4, 5]);
export const WHEEL_SECTORS = Object.freeze([3, 4, 5, 3, 4, 5]);
export const SECTOR_ANGLE = 360 / WHEEL_SECTORS.length;
export const SPIN_DURATION_MS = 3200;

// Land the server-selected sector at the fixed pointer after five full turns.
export function winningRotation(discount) {
  const index = WHEEL_SECTORS.indexOf(discount);
  if (!DEFAULT_WINNING_DISCOUNTS.includes(discount)) throw new Error('Невідомий виграш колеса');
  return 5 * 360 + (360 - index * SECTOR_ANGLE) % 360;
}
